import React from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { Groups, randTask, UNLVDate } from "../utils";
import "../Home.css";
import Grid from "@material-ui/core/Grid";
import block from "./assets/game.PNG";
import read from "./assets/reading.PNG";
import uuid from "uuid/v4";

var id, icon_click_time;

function Home() {
  // Variables for different groups
  var task;
  var taskInfo;
  var source;
  // Logic for determining string literals 
  if (randTask === 1) {  // Reading group
    task = "reading";
    taskInfo = "read a passage about generative AI applications and answer four multiple-choice quiz questions";
    source = read;
  } else {  // Gaming group
    task = "gaming";
    taskInfo = "score points by destroying bricks through the use of a platform and bouncing ball";
    source = block;
  }

  // Get the users uuid and id (their login number)
  const group = Groups[randTask].order;
  id = uuid();
  localStorage.setItem("unique_id", id);
  console.log("unique id = " + id);

  // Log when the user starts the task
  const home = () => {
    icon_click_time = UNLVDate();
    console.log("home icon clicking time " + icon_click_time);
    localStorage.setItem("home_icon_click_time", icon_click_time);
  };

  return (
    <div className="myhome">
      <h1 style={{ fontSize: 30, color: "black", fontFamily: "Impact, Charcoal, sans-serif", letterSpacing: 2.5 }}>WELCOME TO OUR MSN PROJECT!</h1>
      <br></br>
      <p className="info-divs">
          You will soon begin the {task} task. Your objective is to achieve the highest score
          to earn an extra monetary incentive for your excellent performance. We will provide additional
          monetary compensation to participants who score in the top 5% among all participants’
          scores.
      </p>
      <br></br>
      <p className="info-divs">
          Specifically, in this task, you will {taskInfo}. You will have five minutes
          to complete the task. At the end of the task, your final score will be recorded and compared
          with other participants who performed the same task. At the end of this study, we will provide
          the reward as a bonus payment to the top 5% highest-scoring participants, in addition to your
          payment for participating in this study.
      </p>
      <br></br>
      <h2>When ready, click on the icon below to start your task.</h2>
      <br></br>
      <br></br>
      <Grid justifyContent="space-evenly" space={5} container>
        <Button variant="outlined" style={{ textTransform: "none", fontSize: 20 }} size="small" color="primary" onClick={home}>
          <Link to={group[0]}>
            <img src={source} alt="Cannot Display!" width="120" height="120" />
          </Link>
        </Button>
      </Grid>
    </div>
  );
}

export default Home;
